module.exports = __webpack_public_path__ + "static/headline_typo-8b71588c5d799f7258d7664358256b37.svg";